<template>
  <a ref="loadButton" style="display: none"></a>
  <ConfirmDialog ref="confirm" />
  <NdsDlg
      v-if="selectedApplic"
      :isOpen.sync="isNdsDlgOpen"
      :application="selectedApplic"
      :offer-price-with-nds="selectedApplic.offerPriceWithNds"
      @update:isOpen="val => {
      isNdsDlgOpen = val;
      if (!val) selectedApplic = null;
    }"
  />

  <v-dialog persistent width="300" :model-value="!!loadingDialogText" :scrim="false">
    <v-card color="primary" dark>
      <v-card-text>
        {{ loadingDialogText ? $t(loadingDialogText) : loadingDialogText }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-container class="containerCardsWide">
    <v-row v-if="loading" align="start">
      <v-col align="center">
        <v-progress-circular indeterminate color="primary" />
      </v-col>
    </v-row>

    <v-row
      v-if="!loading && !errorText"
      align="start"
      justify="center"
      class="d-flex align-self-start"
    >
      <v-col>
        <GeneralInfo
          v-model:name="procedure.goodName"
          :type="type"
          :types="getTypes"
          :registry-number="procedure.registryNumber"
          :maxStartPrice="procedure.startMaxPrice"
          :isWithoutStartMaxPrice="procedure.isWithoutStartMaxPrice"
          :isClosed="procedure.isClosed"
          :isNds="procedure.isNds"
        >
          <StatusInfo
            :date="formattedDate"
            :name="isView ? $t('Дата и время подачи заявки') : procedure.statusText"
            :code="procedure.statusCode"
            :status-style="statusColor"
          />
        </GeneralInfo>

        <subject-info
          class="mb-3"
          v-model:subject="procedure.subject"
          v-model:start-max-price="procedure.startMaxPrice"
          v-model:is-without-start-max-price="procedure.isWithoutStartMaxPrice"
          v-model:additional-information="procedure.additionalInformation"
          :isApplication = true
        />

        <v-form v-model="valid" @submit.prevent ref="form">
          <SupplierRequirementValues
            v-if="!loading && supplierRequirementValues?.length > 0"
            :supplier-requirement-values="supplierRequirementValues"
            :supplier-requirement-documents="supplierRequirementDocuments"
            :mode="mode"
            :errors="errors"
            @upload="onSupplierRequirementDocumentUpload"
            @delete="onSupplierRequirementDocumentDelete"
            @download="downloadSupplierRequirementDocument"
            @date-change="onRequirementDateChange"
            @error="showError"
          />

          <Card v-if="showOfferCard">
            <div v-if="isView">
              <div class="cardTitle">{{ $t('Ценовое предложение') }}</div>
              <span
                class="price"
                :style="{ cursor: ndsRate !== null ? 'pointer' : 'default' }"
                @click="ndsRate !== null ? openDialog() : null"
              >
                <div class="price">
                  {{ priceValueByView }}
                </div>
              </span>
            </div>

            <div v-else>
              <div class="cardTitle">{{ $t('Ценовое предложение') }}<sup>*</sup></div>
              <div class="card-extra">
                {{ priceDescription }}
              </div>
            </div>

            <div v-if="isEdit" class="d-flex flex-column ga-2 w-50">
              <div class="d-flex flex-row ga-2">
                <div class="form-money-container w-100">
                  <MoneyInput
                    label="Ценовое предложение без НДС"
                    v-model="price"
                    :max="positions.length === 0 ? maxPriceWithCurrentNds : null"
                    :hint="moneyHint"
                    :disabled="positions.length > 0"
                    :class="{ 'disabled not-required': positions.length > 0 }"
                    :rules="(positions.length === 0 || somePositionHasCorrectPrice) ? [].concat(validation.number(0.01, maxPriceWithCurrentNds)) : []"
                    @blur="onPriceBlur"
                  />
                  <span class="form-money-symbol">$</span>
                </div>
                <div class="w-50">
                  <SelectInput
                    class="required"
                    label="Ставка НДС"
                    v-model="ndsId"
                    item-title="name"
                    item-value="id"
                    :items="ndsList"
                    :rules="[].concat(validation.required())"
                  />
                </div>
              </div>
              <div
                v-if="isShowPriceNds()"
                class="d-flex flex-row ga-2"
              >
                <div class="form-money-container w-100">
                  <MoneyInput
                    label="Ценовое предложение с НДС"
                    v-model="priceNds"
                    :max="positions.length === 0 ? MAX_PRICE : null"
                    :hint="moneyHintNds"
                    :disabled="positions.length > 0"
                    :class="{ 'disabled not-required': positions.length > 0 }"
                    :rules="positions.length === 0 ? [].concat(validation.number(0.01, 999_999_999_999.99)) : []"
                    @blur="onPriceNdsBlur"
                  />
                  <span class="form-money-symbol">$</span>
                </div>
                <div class="w-50">
                  <span class="price-nds-diff">{{ (priceNds <= MAX_PRICE && price <= maxPriceWithCurrentNds) ? priceNdsDiff : $t('(в т.ч. НДС -)') }}</span>
                </div>
              </div>
            </div>
          </Card>

          <div v-if="positions.length">
            <ApplicationPositions
              v-if="isEdit && !procedureApplicationStore.hideOfferPrice"
              :positions="positions"
              :procedure="procedure"
              :nds-rate="ndsRate"
              :price="price"
              :price-nds="priceNds"
              :valid="priceNds <= MAX_PRICE && price <= maxPriceWithCurrentNds"
            />

            <PositionsView
              v-else
              ref="positionView"
              :positions="formattedPositions"
              :part-of-volume="procedure.partOfVolume"
              :by-application="!procedureApplicationStore.hideOfferPrice"
              :show-sub-title-hint="!procedureApplicationStore.hideOfferPrice"
              :nds-rate="ndsRate"
              :is-nds="procedure.isNds"
              :procedure-type="procedure.typeCode"
              :procedure-step="procedure.statusCode"
              :selectable="isEdit && procedureApplicationStore.positionsSelectable"
              :selectable-caption="isEdit && procedureApplicationStore.positionsSelectableCaption"
              :show-start-max-price="showStartMaxPrice"
              :show-sum-price="showSumPrice"
            />
          </div>

          <component
              v-if="viewStageComponent && isEdit"
              :is="viewStageComponent"
              :procedure="procedure"
          />

          <FileInput
            class="not-required no-gap"
            title="Документы заявки"
            subtitle="Загрузите документы, которые войдут в состав Вашей заявки"
            :required="isView ? false : procedureApplicationStore.isRequiredDocuments"
            :without-sub-title="isView"
            :is-edit="isEdit"
            :upload-extensions="allowedUploadExtensions"
            :documents="documents"
            :upload-file="onUpload"
            :delete-file="onDocDelete"
            :download-file="downloadDocument"
            :download-all-files="downloadDocuments"
            :file-rules="rules.checkFile"
            :on-error="showError"
            :format-file-info="[
              (file) => formatMinuteTimeNoTZ(file.createdAt),
              (file) => file.fileSizeFmt.toLowerCase(),
            ]"
          >
            <template v-slot:file-icon="{ document }">
              <FileIcon :document="document" />
            </template>
          </FileInput>

          <div class="d-flex justify-end align-center ga-3" v-if="isEdit">
            <v-btn
              v-if="
                access.canApplyApplication &&
                (application.id === null || application.isDraft)
              "
              color="primary"
              density="comfortable"
              variant="outlined"
              @click="onSave()"
            >{{ $t('Сохранить') }}</v-btn>

            <v-btn
              v-if="access.canEditApplication"
              color="primary"
              density="comfortable"
              variant="outlined"
              @click="closeApplication()"
            >{{ $t('Отозвать заявку') }}</v-btn>

            <v-btn
              v-if="
                access.canApplyApplication &&
                (application.id === null || application.isDraft)
              "
              color="primary"
              density="comfortable"
              variant="elevated"
              :disabled="disabledPublishOrUpdate()"
              @click="accept()"
            >{{ $t('Подать заявку') }}</v-btn>

            <v-btn
              v-if="
                access.canApplyApplication &&
                !(application.id === null || application.isDraft)
              "
              color="primary"
              density="comfortable"
              variant="elevated"
              :disabled="disabledPublishOrUpdate()"
              @click="accept()"
            >{{ $t('Обновить заявку') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <ErrorException
      :errorText="errorText"
    />
  </v-container>
</template>

<script>
import { toast } from '@/lib/toast';
import api from '@/api';
import Config from '@/config';
import Decimal from 'decimal.js-light';
import {
  formatByteSize,
  formatMinuteTime,
  formatDateWithOnlyTime,
  formatMinuteTimeNoTZ,
  daysUntil,
  formatPrice,
  formatMoneyText,
} from '@/filters';
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import MoneyInput from '@/components/form/MoneyInput';

import GeneralInfo from '../components/procedure/GeneralInfo';
import StatusInfo from '../components/procedure/StatusInfo.vue';
import FileInput from '@intec/vue-components/form/FileInput.vue';
import Card from "@intec/vue-components/form/Card.vue";
import SelectInput from '@intec/vue-components/form/SelectInput.vue';
import SubjectInfo from "../components/procedure/SubjectInfo.vue";
import ErrorException from "../components/ErrorException.vue";
import validation from "@/components/validation";
import { checkFileValidation } from '@/lib/file';
import { calcNds, calcPriceNdsByPrice, calcPriceByPriceNds } from "@/lib/nds";
import { useProcedureStepStore } from "@/stores/procedureStepStore";
import { useLibraryStore } from "@/stores/library";
import { useProcedureApplicationStore } from "@/stores/procedureApplicationStore";
import { mapStores } from "pinia";
import {useViewProcedureStageComponentStore} from "@/stores/viewProcedureStageComponentStore";
import ApplicationPositions from "@/components/positions/ApplicationPositions.vue";
import PositionsView from "@/components/positions/PositionsView.vue";
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";
import { SUPPLIER_REQUIREMENT_TYPE } from '@/lib/supplierRequirement';
import SupplierRequirementValues from "@/components/supplierRequirements/SupplierRequirementValues.vue";
import FileIcon from "@/components/FileIcon.vue";
import { useApplicationCalculator } from '@/lib/application';
import {useSpecificationOrderStore} from "@/stores/component/procedure/specificationOrderStore";

const MAX_PRICE = 999_999_999_999.99;

export default {
  name: 'ProcedureApplication',
  components: {
    SupplierRequirementValues,
    FileIcon,
    NdsDlg,
    PositionsView,
    SelectInput,
    ApplicationPositions,
    GeneralInfo,
    SubjectInfo,
    ErrorException,
    StatusInfo,
    MoneyInput,
    FileInput,
    ConfirmDialog,
    Card,
  },
  props: {
    procedureId : {
      type: String,
      required: true
    },
    applicationId : {
      type: String
    },
    mode: {
      type: String,
      required: true
    }
  },
  setup() {
    const specificationOrderStore = useSpecificationOrderStore();

    return {specificationOrderStore};
  },
  data() {
    return {
      valid: true,
      loading: false,
      errorText: null,
      isAdmin: Config.getUser().hasRole('ROLE_ADMIN'),
      type: null,
      priceNds: null,
      ndsId: null,
      selectedApplic: null,
      isNdsDlgOpen: false,
      ndsList: [],
      showStartMaxPrice: false,
      showSumPrice: false,
      procedure: {
        id: '',
        typeName: '',
        typeCode: '',
        registryNumber: '',
        goodName: '',
        subject: '',
        goodQuantityUnits: '',
        startMaxPrice: {
          type: Number|String,
          default: 0
        },
        shippingCondition: '',
        statusText: '',
        publishedAt: null,
        organizerName: '',
        applicationDeadline: null,
        additionalInformation: null,
        isWithoutStartMaxPrice: false,
        partOfVolume: false,
        isNds: false
      },
      contragent: {
        ndsId: null,
      },
      errors: {},
      positions: [],
      types: [],
      application: {
        id: null,
        winnerAt: null,
        isCanceled: false,
        isDraft: true,
        offerPrice: null,
        ndsId: null,
        createdAt: null,
        positionsSum: null,
      },
      access: {
        canSeeApplicationDocuments: false,
        canUploadDocuments: false,
        canApplyApplication: false,
        canEditApplication: false,
      },
      supplierRequirementValues: [],
      allowedUploadExtensions: (Config.get('config').allowedUploadExtensions || []).join(','),
      rules: {
        checkFile: [checkFileValidation],
      },
      loadingDialogText: null,
      documents: [],
      documentsForDelete: [],
      documentKey: 1000000000,
      files: [],
      supplierRequirementDocumentKey: 1,
      supplierRequirementDocuments: {},
      supplierRequirementFiles: [],
      formatMinuteTime,
      formatDateWithOnlyTime,
      formatMinuteTimeNoTZ,
      daysUntil,
      formatPrice,
      validation,
      SUPPLIER_REQUIREMENT_TYPE,
      MAX_PRICE,
    };
  },
  computed: {
    ...mapStores(useProcedureStepStore),
    ...mapStores(useProcedureApplicationStore),
    ...mapStores(useLibraryStore),
    showOfferCard() {
      return !this.loading && !this.procedureApplicationStore.hideOfferCard;
    },
    viewStageComponent() {
      const viewStageStore = useViewProcedureStageComponentStore();
      return viewStageStore.getComponentByType(this.procedure.typeCode);
    },
    isView() {
      return this.mode === 'VIEW';
    },
    isEdit() {
      return this.mode === 'EDIT';
    },
    formattedDate() {
      if (this.isView) {
        return this.formatDateWithOnlyTime(this.application.createdAt);
      } else {
        const deadline = this.procedure?.applicationDeadline;
        const deadlineStr = deadline ? this.formatDateWithOnlyTime(deadline) : '-';
        const days = this.daysUntil(deadline) || 0;

        return this.$t(`до: {_1} ({_2} дней)`, {'_1': deadlineStr, '_2': days});
      }
    },
    priceValueByView() {
      const nds = this.ndsList.find(nds => nds.id === this.application.ndsId)
      const calculator = useApplicationCalculator(
          this.application,
          this.positions,
          nds?.rate,
          this.specificationOrderStore.applicationItemPriceField
      );
      const currentValue = calculator.getTotalCostNds();
      return formatMoneyText(currentValue);
    },
    formattedPositions() {
      let poses = this.positions;
      if (!this.procedureApplicationStore.hideOfferPrice) {
        poses = poses.filter(pos => pos.price > 0);
      }
      if (this.isView && this.procedureApplicationStore.positionsSelectable) {
        poses = poses.filter(pos => pos.selected);
      }

      return poses;
    },
    statusColor() {
      return this.procedureStepStore.getStatusStyle(this.procedure.statusCode);
    },
    getTypes() {
      return this.types.map((elem) => {
        return { title: elem.name, value: elem.code };
      });
    },
    moneyHint() {
      if (!this.procedure.startMaxPrice) {
        return ''
      }

      if (this.positions.length > 0) {
        return this.positionsError;
      }

      return this.application.offerPrice > this.procedure.startMaxPrice ? this.$t('Сумма больше НМЦ') : '';
    },
    moneyHintNds() {
      if (!this.procedure.startMaxPrice) {
        return ''
      }
      const priceNdsDecimal = new Decimal(this.priceNds || 0);
      const startMaxPriceDecimal = new Decimal(this.procedure.startMaxPrice || 0);

      return priceNdsDecimal.gt(startMaxPriceDecimal) ? this.$t('Сумма больше НМЦ') : '';
    },
    ndsRate() {
      const ndsItem = this.ndsList.find(item => item.id === this.ndsId);
      return ndsItem && ndsItem?.rate ? parseFloat(ndsItem.rate) : null;
    },
    maxPriceWithCurrentNds() {
      return calcPriceByPriceNds(this.MAX_PRICE, this.ndsRate)
    },
    price: {
      get() {
        const value = this.positions.length === 0
            ? this.application.offerPrice
            : this.positionsSum;

        return typeof value === 'string' ? parseFloat(value) : value;
      },
      set(value) {
        if (this.positions.length === 0) {
          this.application.offerPrice = value;
        }
      }
    },
    priceDescription() {
      return this.$t(this.positions.length ? 'Заполните цены по позициям в блоке "Позиции ТРУ"'
        : 'Заполните основную информацию о Вашем ценовом предложении');
    },
    positionsSum() {
      return this.positions.reduce((acc, item) => acc + (item.price ? item.quantity * item.price : 0), 0);
    },
    positionsSumValid() {
      return (this.positionsSum > 0
        && this.positionsSum <= this.MAX_PRICE);
    },
    positionsError() {
      if (this.application.positionsSum > this.MAX_PRICE) {
        return this.$t('Сумма по позициям превышает допустимый лимит')
      }

      if (Number(this.procedure.startMaxPrice) > 0 && this.application.positionsSum > Number(this.procedure.startMaxPrice)) {
        return this.$t('Сумма по позициям больше НМЦ');
      }
    },
    somePositionHasCorrectPrice() {
      return this.positions.some((pos) => pos.price > 0)
    },
    hasAtLeastOneDocument() {
      return this.documents && this.documents.length > 0;
    },
    priceNdsDiff() {
      const diff = calcNds(this.priceNds, this.price);

      return this.$t(`(в т.ч. НДС {_1} $)`, { '_1': this.formatPrice(diff) });
    },
  },
  methods: {
    calcPriceNdsByPrice,
    formatMoneyText,
    isShowPriceNds() {
      return !!this.ndsRate;
    },
    applyPriceRecalculation({ price = this.price, priceNds = this.priceNds } = {}) {
      const rate = this.ndsRate;
      if (isNaN(rate)) return;

      const hasPrice = price != null && !isNaN(price);
      const hasPriceNds = priceNds != null && !isNaN(priceNds);

      if (hasPrice) {
        const calculator = useApplicationCalculator(this.application, this.positions, rate);
        this.priceNds = Math.min(calculator.getTotalCostNds(), MAX_PRICE);
      } else if (hasPriceNds) {
        this.price = Math.min(calcPriceByPriceNds(priceNds, rate), this.maxPriceWithCurrentNds);
      }
    },
    onPriceBlur() {
      this.applyPriceRecalculation({ price: this.price, priceNds: null });
    },
    onPriceNdsBlur() {
      this.applyPriceRecalculation({ price: null, priceNds: this.priceNds });
    },
    async loadForm() {
      this.loading = true;
      this.errorText = null;

      try {
        const { procedure, positions, contragent, application, applicationDocuments, access, supplierRequirementValues } =
          await api.get(`/applications/procedure/${this.procedureId}/${this.mode}`);

        const data = this.libraryStore.callFunctionByCode('getPositionsViewOptions', {
          procedureType: procedure.typeCode,
          procedureStep: procedure.statusCode,
        });
        this.libraryStore.callActionByCode('getApplicationItemPriceField', {
          procedureType: procedure.typeCode
        });

        this.showStartMaxPrice = data.showStartMaxPrice ?? false;
        this.showSumPrice = data.showSumPrice ?? false;
        this.procedure = procedure;
        this.positions = positions;
        this.contragent = contragent;
        this.ndsId = application.ndsId ?? contragent.ndsId ?? null;

        this.types = [
          {
            code: this.procedure.typeCode,
            name: this.procedure.typeName,
          },
        ];
        this.type = this.procedure.typeCode;

        this.application = application;
        this.documents = applicationDocuments;
        this.access = access;
        this.supplierRequirementValues = supplierRequirementValues;
        this.supplierRequirementValues?.forEach((elem) => {
          elem.valueDate = elem.valueDate ? new Date(
            elem.valueDate,
          ) : null;
          this.supplierRequirementDocuments[elem.supplierRequirementId] = elem.valueFile ? [elem.valueFile] : [];

          // Добавляем "Не выбрано" в список.
          if (Array.isArray(elem.list)) {
            elem.list = [
              ...elem.list,
              { id: null, value: this.$t('Не выбрано') }
            ];
          }
        })

        await this.loadNdsList();

        this.libraryStore.callActionByCode('initProcedureApplicationOptions', {
          procedureType: this.type,
          statusCode: this.procedure.statusCode,
          offerPrice: this.application.offerPrice
        });
      } catch (e) {
        if (e.status === 403) {
          this.errorText = e.response.data;
        } else {
          toast.error(e.message);
        }
      } finally {
        this.loading = false;
      }
    },
    async loadNdsList() {
      try {
        const { entries } = await api.get('/vocab/nds');
        this.ndsList = [
          ...entries,
          { id: null, name: this.$t('Не выбрано') }
        ];
      } catch (e) {
        toast.error('Не удалось загрузить ставки НДС');
      }
    },
    checkSelectedPositions() {
      if (!this.procedureApplicationStore.positionsSelectable) return true;

      const selected = this.$refs.positionView?.selected ?? [];
      if (!selected.length) {
        toast.error(this.$t('Не выбрано ни одной позиции для участия.'));
        return false;
      }

      this.positions.forEach(item => {
        item.selected = selected.includes(item.procedureItemId);
      });

      return true;
    },
    async onSave() {
      const application = await this.$refs.confirm.open(
        'Сохранение заявки',
        this.$t(`Вы действительно хотите сохранить заявку на процедуру {_1}?`, {'_1': this.procedure.registryNumber}),
      );

      if (application) {
        try {
          const procedureId = this.procedure.id;
          const formData = new FormData();

          let offerPrice = null;
          let ndsId = null;
          if (!this.procedureApplicationStore.hideOfferPrice) {
            offerPrice = this.price;
            ndsId = this.ndsId;
          }

          this.supplierRequirementValues.forEach((value) => {
            if (value.type === SUPPLIER_REQUIREMENT_TYPE.FILE && value.valueFile) {
              formData.append(`supplierRequirementFiles_${value.supplierRequirementId}`, value.valueFile);
            }
          });

          if (!this.checkSelectedPositions()) return;

          if (!(await this.$refs.form.validate()).valid) {
            return;
          }

          formData.append('data', JSON.stringify({
            ...this.application,
            offerPrice: offerPrice,
            positions: this.positions,
            ndsId: ndsId,
            supplierRequirementValues: this.supplierRequirementValues,
          }));

          const response = await api.post(`/applications/saveProcedure/${this.procedureId}`, formData);
          this.files.map((file) =>
            this.onUpload(file, response.applicationId),
          );
          this.files = [];
          this.documentsForDelete.map((document) =>
            this.onDocDelete(document, response.applicationId),
          );
          this.documentsForDelete = [];
          this.showProcedures();
        } catch (e) {
          toast.error(e.message);
        }

        this.loadingDialogText = null;
      }
    },
    async onUpload(file, applicationId) {
      if (applicationId) {
        const formData = new FormData();

        formData.append('file', file);
        formData.append('procedureId', this.procedureId);

        await api.post(`/applications/${applicationId}/documents`, formData);
      } else {
        this.files = [file, ...this.files];

        this.documents = [
          {
            ...file,
            id: this.getNextKey(),
            fileName: file.name,
            fileSizeFmt: formatByteSize(file.size),
            createdAt: new Date(),
            isNew: true,
          },
          ...this.documents,
        ];
      }
    },
    getNextKey() {
      return this.documentKey++;
    },
    async onSupplierRequirementDocumentUpload(file, supplierRequirementValue) {
      supplierRequirementValue.valueFile = file

      this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId] = [
        {
          ...file,
          createdAt: new Date(),
          fileName: file.name,
          fileSizeFmt: formatByteSize(file.size),
          id: this.getNextSupplierRequirementDocumentKey(),
          isNew: true
        },
        ...this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId]
      ]
    },
    getNextSupplierRequirementDocumentKey() {
      return this.supplierRequirementDocumentKey++;
    },
    async onSupplierRequirementDocumentDelete(document, supplierRequirementValue) {
      const findedDoc = this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId].find(doc => doc.id === document.id);
      const findedValue = this.supplierRequirementValues.find(value => value.supplierRequirementId == supplierRequirementValue.supplierRequirementId)
      findedValue.valueFile = null;
      this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId] = this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId].filter(
        (doc) => doc != findedDoc,
      );
    },
    async downloadSupplierRequirementDocument(documentId, supplierRequirementValue) {
      const findedDoc = this.supplierRequirementDocuments[supplierRequirementValue.supplierRequirementId].find(doc => doc.id === documentId);
      if (this.application?.id && supplierRequirementValue.id && !findedDoc.isNew) {
        window.location.href = supplierRequirementValue?.valueFile?.downloadUrl;
      } else {
        const findedValue = this.supplierRequirementValues.find(value => value.supplierRequirementId == supplierRequirementValue.supplierRequirementId)
        const file = findedValue.valueFile;
        const link = this.$refs.loadButton;
        link.href = URL.createObjectURL(file);
        link.download = file.name;
        link.click();
      }
    },
    async onDocDelete(item, applicationId) {
      if (applicationId) {
        const documentId = item.id;
        const formData = new FormData();

        formData.append('documentId', documentId);

        await api.delete(`/applications/${applicationId}/documents/${documentId}`, formData);
      } else {
        this.files = this.files.filter(
          (file) => file.name !== item.fileName,
        );
        this.documents = this.documents.filter(
          (doc) => doc.id !== item.id,
        );
        if (!item.isNew) {
          this.documentsForDelete = [
            {
              id: item.id,
            },
            ...this.documentsForDelete,
          ];
        }
      }
    },
    async downloadDocument(documentId) {
      const findedDoc = this.documents.find(doc => doc.id === documentId);
      if (this.applicationId && !findedDoc.isNew) {
        window.location.href = `/applications/${this.applicationId}/documents/${documentId}`
      } else {
        const link = this.$refs.loadButton;
        const findedFile = this.files.find(file => file.name === findedDoc.fileName)
        link.href = URL.createObjectURL(findedFile);
        link.download = findedFile.name;
        link.click();
      }
    },
    async downloadDocuments() {
      window.location.href = `/applications/${this.applicationId}/documents`;
    },
    async accept() {
      let message, route, title;
      if (this.applicationId === null || this.application.isDraft) {
        title = 'Подача заявки';
        message = ['подать', 'подается', 'подана'];
        route = 'procedure'
      } else {
        title = 'Редактирование заявки';
        message = ['обновить', 'обновляется', 'обновлена'];
        route = 'editProcedure'
      }

      if (!this.checkSelectedPositions()) return;

      if (!(await this.$refs.form.validate()).valid) {
        return;
      }

      const application = await this.$refs.confirm.open(
        title,
        this.$t(`Вы действительно хотите ${message[0]} заявку на процедуру {_1}?`, {'_1': this.procedure.registryNumber}),
      );

      if (application) {
        try {
          const formData = new FormData();

          this.loadingDialogText = 'Заявка ' + message[1];
          this.application.isDraft = false;

          let offerPrice = null;
          let ndsId = null;
          if (!this.procedureApplicationStore.hideOfferPrice) {
            offerPrice = this.price;
            ndsId = this.ndsId;
          }

          this.supplierRequirementValues.forEach((value) => {
            if (value.type === SUPPLIER_REQUIREMENT_TYPE.FILE && value.valueFile) {
              formData.append(`supplierRequirementFiles_${value.supplierRequirementId}`, value.valueFile);
            }
          });

          formData.append('data', JSON.stringify({
            ...this.application,
            offerPrice: offerPrice,
            positions: this.positions,
            ndsId: ndsId,
            supplierRequirementValues: this.supplierRequirementValues,
          }));

          const response = await api.post(
            `/applications/${route}/${this.procedureId}`,
            formData,
          );

          if (this.files && this.files.length > 0) {
            await Promise.all(this.files.map(file => {
              return this.onUpload(file, response.applicationId);
            }));

            this.files = [];
          }
          await Promise.all(this.documentsForDelete.map((document) =>
              this.onDocDelete(document, response.applicationId)
          ));
          this.documentsForDelete = [];

          toast.info(`Ваша заявка ${message[2]} успешно`);

          this.showProcedures();
        } catch (e) {
          toast.error(e.message);
        }
        this.loadingDialogText = null;
      }
    },
    async closeApplication() {
      const application = await this.$refs.confirm.open(
        'Отзыв заявки',
        this.$t(`Вы действительно хотите отозвать поданную заявку по процедуре {_1}?`, {'_1': this.procedure.registryNumber}),
      );

      if (application) {
        try {
          this.loadingDialogText = 'Заявка отзывается';

          await api.delete(`/procedures/cancelApplication/${this.procedureId}`);

          this.showProcedures();
        } catch (e) {
          toast.error(e.message);
        }
        this.loadingDialogText = null;
      }
    },
    checkPositions() {
      if (this.positions.length) {
        return !this.positionsSumValid
            || !this.somePositionHasCorrectPrice
            || !this.ndsId;
      }
      return !this.valid || !this.ndsId;
    },
    disabledPublishOrUpdate() {
      const foundEmptyRequiredFile = this.supplierRequirementValues.find(elem => {
        return elem.type === SUPPLIER_REQUIREMENT_TYPE.FILE && elem.isRequired && !elem.valueFile
      });

      const foundEmptyRequiredBool = this.supplierRequirementValues.some(elem => {
        return elem.type === SUPPLIER_REQUIREMENT_TYPE.BOOL && elem.isRequired && !elem.valueBool;
      });

      const foundEmptyRequiredDate = this.supplierRequirementValues.some(elem => {
        return elem.type === SUPPLIER_REQUIREMENT_TYPE.DATE && elem.isRequired && !elem.valueDate;
      });

      return (this.checkPositions() && !this.procedureApplicationStore.isRequiredDocuments && this.procedureApplicationStore.isRequiredPositions)
        || (this.procedureApplicationStore.isRequiredDocuments && !this.hasAtLeastOneDocument)
        || Object.keys(this.errors).length
        || foundEmptyRequiredDate
        || foundEmptyRequiredFile
        || foundEmptyRequiredBool;
    },
    showProcedures() {
      this.$router.push({ name: 'procedures.all' });
    },
    showError(error) {
      toast.error(error);
    },
    openDialog() {
      this.isNdsDlgOpen = true;
      this.selectedApplic = {
        ...this.application,
        positions: this.positions,
      }
    },
    /**
     * Валидация обязательности поля.
     *
     * @param {*}      newValue   Новое значение поля.
     * @param {string} fieldName  Наименование поля.
     *
     * @return {boolean} Возвращает true, если поле не заполнено. Иначе false.
     */
    validateRequired(newValue, fieldName) {
      let hasErrors = false;
      if (newValue === '' || newValue === null) {
        this.errors[fieldName] = 'Это поле обязательно для заполнения';
        hasErrors = true;
      }
      return hasErrors;
    },
    /**
     * Обработка события изменения даты в требования.
     */
    onRequirementDateChange(newValue, fieldName, isRequired = false) {
      this.errors = {};
      if (isRequired) {
        this.validateRequired(newValue, fieldName);
      }
    },
  },
  watch: {
    ndsId() {
      this.applyPriceRecalculation();

      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
    positions: {
      handler() {
        if (this.positions.length > 0) {
          this.applyPriceRecalculation();
        }
      },
      deep: true,
    }
  },
  async mounted() {
    await this.loadForm();
    this.onPriceBlur();
  },
};
</script>

<style lang="scss" scoped>
$color-black: #000;
$color-error: #a01111;
$color-gray: #949494;
$color-gray-2: #868686;

.cardTitle sup {
  color: $color-error;
}

.card-extra {
  font-size: 14px;
  color: $color-gray;
}

.form-money-container {
  position: relative;

  .form-money-symbol {
    color: $color-gray-2;
    position: absolute;
    top: 18px;
    right: 16px;
  }
}

.price {
  font-weight: 500;
  font-size: 18px;
}

.price-nds-diff {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 0.01px solid rgb(var(--blue-blue-secondary-hover));
  border-radius: 8px;
  font-size: 14px;
  color: rgb(var(--input-text-color));
  white-space: nowrap;
  height: 58.5px;
  background-color: rgb(var(--disabled-grey));
  transition: background-color 0.5s ease;
  pointer-events: none;
}

:deep(.v-select > .v-input__control) {
  height: 58.5px;
}

.required :deep(.v-label::after) {
  content: ' *';
  color: rgba(var(--error-color));
}

.required-star {
  margin-left: 4px;
  color: rgba(var(--error-color)) !important;
  font-size: 1rem !important;
}

:deep(.not-required .v-label::after) {
  content: '';
  color: transparent;
}

:deep(.v-input__details) {
  min-height: 10px;

  .v-messages > .v-messages__message {
    font-size: 12px;
    font-weight: 400;
    padding: 0 12px;
  }
}
:deep(.v-input:not(.v-input--error)) {
  .v-input__details > .v-messages > .v-messages__message {
    color: black;
    opacity: 0.6;
  }
}
.containerCardsWide {
  padding: 0;
}
</style>
